import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
  apiKey: "AIzaSyCAU2TNBu4qMzthfXTwFQSvqsgnp8mjqIk",
  authDomain: "beeldhouwen-aad-5ca86.firebaseapp.com",
  projectId: "beeldhouwen-aad-5ca86",
  storageBucket: "beeldhouwen-aad-5ca86.firebasestorage.app",
  messagingSenderId: "135005496904",
  appId: "1:135005496904:web:13ba7cfad88069b9831a7d",
};


const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
